import { fetchConfig, removeTrapFocus, trapFocus } from "./global.js";


startTrackingCart();
function startTrackingCart() {

  document.querySelectorAll('cart-remove-button')?.forEach((button) => {
    button.addEventListener("click", (event) => {
      removeFromCartGEvents(event.target);
    });
  });

  function removeFromCartGEvents(el) {
    const productItem = el.closest('.cart-item');
    if (!productItem) return;

    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
      'event': 'remove_from_cart',
      'currency': document.querySelector("body").dataset.currency,
      'ecommerce': {
        'items': [{
          item_id: productItem.dataset.id,
          item_name: productItem.dataset.title,
          item_brand: productItem.dataset.brand,
          price: productItem.dataset.price
        }]
      }
    });

    console.log("Remove from cart event");
  }
}
export class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

export class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.maxFailedRetries = 3;

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.maxFailedRetries = 3;
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const itemCo2 = document.querySelectorAll('.cart-item__co2');
    const itemCo2Value = itemCo2.length ? itemCo2[line - 1].value : '';

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      properties: {
        item_co2: itemCo2Value,
      },
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (parsedState.errors) {
          throw new Error(parsedState.errors);
        }

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          const renderCartEvent = new CustomEvent("rendered-cart");
          window.dispatchEvent(renderCartEvent);
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        this.disableLoading();
      })
      .catch((err) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );

        const maxQty = parseInt(err.message.split(" ")[1]);
        if (this.maxFailedRetries > 0) {
          if (maxQty && typeof maxQty === "number") {
            this.updateQuantity(line, maxQty, name);
          }
          this.maxFailedRetries--;
        }

        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}

import "./cart.js";

export class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.showCartDrawerAfterRedirection();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  showCartDrawerAfterRedirection() {
    if (window.location.href.includes("show-cart-drawer")) {
      this.open();
      window.history.replaceState({}, document.title, "/");
    };
  }

  open(triggeredBy) {
    const scrollableTarget = this.querySelector('cart-drawer-items');
    if (scrollableTarget) {
      document.body.classList.add('overflow-hidden', 'relative');
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.querySelector('#CartDrawer-Checkout').addEventListener('click', this.checkoutValidation.bind(this));

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden', 'hide-icons');
  }

  close() {
    document.body.classList.remove('overflow-hidden', 'relative');
    this.querySelector('#CartDrawer-Checkout').removeEventListener('click', this.checkoutValidation.bind(this));
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'hide-icons');
  }

  checkoutValidation(event) {
    const cartDrawerTerms = document.querySelector("#CartDrawer-terms");
    if (!cartDrawerTerms) {
      return;
    }

    if (!cartDrawerTerms.checked) {
      event.preventDefault();
      this.querySelector('.checkout_validation-modal')?.open();
      return false;
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  refetchCartItems() {
    try {
      // cache: "no-store" so returning from checkout doesn't re-render with a stale, HTTP-cached cart.
      fetch(`/cart`, { cache: "no-store" })
        .then(data => { return data.text() }).then((parsedData) => {
          const newCartItems = new DOMParser().parseFromString(parsedData, 'text/html').querySelector("cart-drawer");
          if (newCartItems.querySelectorAll(".cart-item").length) {
            this.querySelectorAll('.is-empty').forEach(isEmptyNode => isEmptyNode.classList.remove("is-empty"));

            const emptyInner = this.querySelector(".drawer__inner-empty");
            if (emptyInner) emptyInner.remove();

            const cartCountdown = this.querySelector(".cart-countdown");
            if (cartCountdown) cartCountdown.classList.remove("hidden");

            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) cartDrawer.classList.remove("is-empty");

            this.parentElement.classList.remove("is-empty");
          }

          const cartItems = this.querySelector("#CartDrawer-CartItems");
          if (cartItems) cartItems.innerHTML = newCartItems.querySelector("#CartDrawer-CartItems").innerHTML;

          const cartFooter = this.querySelector(".drawer__footer-wrapper");
          if (cartFooter) cartFooter.innerHTML = newCartItems.querySelector(".drawer__footer-wrapper").innerHTML;

          // Let dependent UI (e.g. the free-shipping countdown bar) recalculate from the fresh cart.
          window.dispatchEvent(new CustomEvent("rendered-cart"));
        })
    } catch (error) {
      console.error(error);
    }
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      const renderCartEvent = new CustomEvent("rendered-cart");
      window.dispatchEvent(renderCartEvent);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

export class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

export class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// Re-render the cart drawer when the shopper returns from checkout (typically via the browser back
// button). Checkout can change cart-level state — most notably an applied discount code — which the
// cached store page and drawer don't reflect until a reload, leaving the free-shipping bar showing a
// stale "threshold reached" state. We mark the departure to checkout, and on the way back re-fetch
// the cart and refresh the drawer's totals + free-shipping bar in place. See BLE-11137.
(function refreshCartDrawerOnReturnFromCheckout() {
  const RETURN_FLAG = "ob:returning-from-checkout";

  // sessionStorage throws when storage is unavailable (Safari private browsing, disabled cookies,
  // quota exceeded). This runs on every document click, so an uncaught throw would break unrelated
  // click handlers — degrade to "no refresh" instead.
  const setFlag = () => {
    try {
      sessionStorage.setItem(RETURN_FLAG, "1");
    } catch (error) {
      /* storage unavailable */
    }
  };

  const readAndClearFlag = () => {
    try {
      const flag = sessionStorage.getItem(RETURN_FLAG);
      // Clear it whenever it was set, so a later forward navigation doesn't refresh unnecessarily.
      if (flag) sessionStorage.removeItem(RETURN_FLAG);
      return flag;
    } catch (error) {
      return null;
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      const checkoutTrigger = event.target.closest(
        '[name="checkout"], #CartDrawer-Checkout, .shopify-payment-button, a[href*="/checkout"]'
      );
      if (checkoutTrigger) setFlag();
    },
    true
  );

  window.addEventListener("pageshow", (event) => {
    if (!readAndClearFlag()) return;

    const [navigation] = performance.getEntriesByType("navigation");
    const cameBack = event.persisted || navigation?.type === "back_forward";
    if (!cameBack) return;

    const drawer = document.querySelector("cart-drawer");
    if (typeof drawer?.refetchCartItems === "function") drawer.refetchCartItems();
  });
})();
